import { SelectProps } from 'antd';
import moment from 'moment';
import { ReactNode } from 'react';

type TDataItem = Record<string, any>;

type TParseDataToOptionsProps = {
  label?: string;
  value?: string;
  code?: string;
  disabledCallback?: (item: TDataItem) => boolean;
  labelRender?: (label: ReactNode, item: TDataItem) => ReactNode;
};

export const parseDataToOptions = (
  data: TDataItem[],
  {
    label = 'name',
    value = 'id',
    code = '',
    disabledCallback,
    labelRender,
  }: TParseDataToOptionsProps = {},
): SelectProps['options'] => {
  if (!Array.isArray(data)) return [];
  return data.map((item, index) => {
    const itemLabel = item[label];
    const itemValue = item[value];
    const itemCode = item[code];

    return {
      key: `${itemLabel}_${itemValue}_${index}`,
      label: labelRender?.(itemLabel, item) ?? itemLabel,
      value: itemValue,
      code: itemCode,
      disabled: disabledCallback?.(item),
    };
  });
};

export const isGeoDimension = (dimensionField) => {
  return ['geo_country', 'geo_state', 'geo_city', 'geo_isp', 'ip_isp'].includes(dimensionField);
};

export const parseIntervalStr = (interval: string): [moment.Moment, moment.Moment] | null => {
  if (!interval) return null;

  const parts = interval.split('/');
  if (parts.length !== 2) {
    console.error('Invalid interval string format');
    return null;
  }

  const [fromString, toString] = parts;
  const fromDate = moment(fromString);
  const toDate = moment(toString);

  if (!fromDate.isValid() || !toDate.isValid()) {
    console.error('Invalid date format in interval string');
    return null;
  }

  return [fromDate, toDate];
};
